export const SET_TIPOS_INSTITUICOES =
  "TIPOS_INSTITUICOES/SET_TIPOS_INSTITUICOES";
export const SET_TIPO_INSTITUICAO = "TIPOS_INSTITUICOES/SET_TIPO_INSTITUICAO";
export const SET_PAGINATION = "TIPOS_INSTITUICOES/SET_PAGINATION";
